// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Account-__message-report-subscripton__wrapper--1-pas","email":"src-components-Account-__message-report-subscripton__email--2QFxK","button":"src-components-Account-__message-report-subscripton__button--1JsxP","help":"src-components-Account-__message-report-subscripton__help--_qtrV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Account/message-report-subscripton.css
// module id = 1960
// module chunks = 0